import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { recordStatisticsEvent } from '../../../services/statistics-service';
import WireTitle from './wire-title';
import Profile from './profile';
import WireToolsMobile from '../../wire/wire-tools/mobile-view';
import ImageWithListenButton from './shared/image-with-listen-button';
import dt from '../../../shared/theme';

const Container = styled.section`
  display: flex;
  flex-direction: column;
  align-items: flex-end;

  > a > div {
    padding: 18px 20px 0 0;
    border-radius: 0;

    ${props => dt(props).theme.isMedium && `
      height: unset;
    `};
  }

  & > a.image-wrapper {
    &:hover {
      text-decoration: none;
    }
  }

  & > div.text-wrapper {
    display: flex;
    flex-direction: column;
  }

  & > * {
    width: 100%;
  }
`;

const HR = styled.div`
  width: 100%;
  height: 0;
  border-top: 1px solid #D7DFE7;
  margin: 24px 0 8px;
`;

export default function Wire({ wire, position }) {
  const wireUrl = `/wires/${wire.slug}`;

  const handleClick = () => {
    recordStatisticsEvent({
      event: 'link_click',
      statisticable: 'wire',
      id: wire.id,
      clicked_url: wireUrl,
      page: window.location.pathname,
      custom_data: {
        section: 'all_wires',
        page: 'series',
        position,
      },
    });
  };

  const wireClicked = e => {
    e && e.preventDefault();
    handleClick();
    window.location = wireUrl;
  };

  const commentProps = {
    comments: [],
  };

  return (
    <Container>
      {!!wire.primaryImageUrl
        && (
        <a className="image-wrapper" onClick={wireClicked} role="button" tabIndex={0}>
          <ImageWithListenButton wire={wire} section="all_wires" position={position} />
        </a>
        )}
      <div className="text-wrapper">
        <WireTitle wire={wire} onHeaderWire={false} position={position} />
        <Profile profile={wire.profile} />
        <HR />
        <WireToolsMobile
          wireId={wire.id}
          bookmarked={wire.bookmarked}
          commentProps={commentProps}
          isOnROIPage
          position={position}
        />
      </div>
    </Container>
  );
}

Wire.propTypes = {
  wire: PropTypes.shape({
    id: PropTypes.number.isRequired,
    slug: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    primaryImageUrl: PropTypes.string.isRequired,
    mediaTypes: PropTypes.arrayOf(PropTypes.string),
    bookmarked: PropTypes.arrayOf(PropTypes.string),
    profile: PropTypes.shape({
      id: PropTypes.number.isRequired,
      slug: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      organization: PropTypes.string,
    }),
  }).isRequired,
  position: PropTypes.number.isRequired,
};
